import { render, staticRenderFns } from "./DayPicker.vue?vue&type=template&id=1618452d&scoped=true"
import script from "./DayPicker.vue?vue&type=script&lang=js"
export * from "./DayPicker.vue?vue&type=script&lang=js"
import style0 from "./DayPicker.vue?vue&type=style&index=0&id=1618452d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1618452d",
  null
  
)

export default component.exports